import { categories, hotList, featuredArticles, dailyContest, siteInfo } from './home';

export { categories, hotList, featuredArticles, dailyContest, siteInfo };

export const allArticles = [
  {
    id: 1,
    title: '某千万粉丝网红被曝税务问题，工作室连夜发声明回应',
    slug: 'wanghong-shuiwu-wenti',
    category: '网红大瓜',
    categorySlug: 'wanghong-dagua',
    author: '爆料小编',
    time: '2025年7月6日 14:30',
    hotScore: '98.7万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Breaking%20news%20visual%20about%20internet%20celebrity%20scandal%20with%20dramatic%20lighting%2C%20mysterious%20silhouette%2C%20dark%20moody%20atmosphere%2C%20news%20report%20concept%2C%20warm%20accent%20highlights%2C%20editorial%20photography%20style&width=640&height=480&seq=hot-1-2026&orientation=landscape',
    excerpt: '据知情人透露，该网红近三年直播收入超两亿，却存在严重税务申报问题。税务机关已介入调查，工作室连夜发声明称"配合调查"。',
    tags: ['网红税务', '直播收入', '税务机关调查'],
    content: [
      { type: 'paragraph', text: '近日，一位拥有千万粉丝的头部网红因涉嫌税务问题被推上风口浪尖。据知情人士向本中心独家透露，该网红近三年的直播带货收入超过两亿元人民币，但存在严重的税务申报问题。' },
      { type: 'paragraph', text: '根据内部人士提供的资料显示，该网红通过多个壳公司和工作室进行收入分流，以规避个人所得税的高额税率。这种操作模式在行业内并不罕见，但涉及的金额之大令人震惊。' },
      { type: 'heading', text: '事件起因：内部举报引发调查' },
      { type: 'paragraph', text: '事情的导火索是一封匿名举报信。据悉，该举报信直接寄往了当地税务机关，信中详细列举了该网红近三年的收入明细与税务申报之间的巨大差距。举报人疑似为该网红前团队成员，掌握了大量内部财务数据。' },
      { type: 'paragraph', text: '税务机关在收到举报信后迅速启动调查程序。根据相关法律法规，如果查实存在偷逃税款行为，该网红不仅需要补缴税款和滞纳金，还可能面临行政处罚甚至刑事责任。' },
      { type: 'heading', text: '工作室深夜紧急回应' },
      { type: 'paragraph', text: '面对舆论的不断发酵，该网红工作室于深夜发布声明称："我司一直严格遵守国家税收法律法规，所有经营活动均依法纳税。对于网络上的不实传闻，我司将保留追究法律责任的权利。同时，我司正在积极配合相关部门的调查工作。"' },
      { type: 'paragraph', text: '然而，这则声明并未平息网友的质疑。有网友发现，该网红近两年频繁注册和注销公司，这种异常行为引起了更多猜测。一位资深税务律师表示，频繁变更经营主体是避税操作的常见手法之一。' },
      { type: 'heading', text: '行业影响：头部主播人人自危' },
      { type: 'paragraph', text: '此事件在直播行业内引发强烈震动。多位业内人士向本中心表示，头部主播的税务合规问题一直是一个灰色地带。此次事件的曝光可能会引发一轮全行业的税务自查自纠。' },
      { type: 'paragraph', text: '某MCN机构高管匿名透露："这次事件的信号非常明确——监管部门对直播行业的税收征管将越来越严格。我们已经在内部要求所有签约主播进行全面税务合规审查。"' },
      { type: 'paragraph', text: '此事件的后续发展，本中心将持续关注并第一时间为各位吃瓜群众带来最新进展。' },
    ],
    relatedArticleIds: [2, 5, 8],
  },
  {
    id: 2,
    title: '知名选秀节目选手私生活混乱，多位当事人同时发声',
    slug: 'xuanxiu-xuanshou-sishenghuo',
    category: '娱乐八卦',
    categorySlug: 'yule-bagua',
    author: '吃瓜前线',
    time: '2025年7月6日 11:00',
    hotScore: '87.3万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20concept%20with%20spotlight%20on%20stage%2C%20dark%20theater%20background%2C%20mysterious%20figure%20in%20shadows%2C%20cinematic%20noir%20style%2C%20warm%20tone%20highlights&width=640&height=480&seq=hot-2-2026&orientation=landscape',
    excerpt: '节目刚结束不久，选手就被扒出大量私生活黑料，涉及多人关系。多位当事人同时发声，事件持续升级中。',
    tags: ['选秀节目', '私生活黑料', '多人发声'],
    content: [
      { type: 'paragraph', text: '某热门选秀节目刚刚落幕，一位人气选手便被卷入私生活风波。据多方信息汇总，该选手在参赛期间和赛后，同时与多名异性保持暧昧关系，这一消息一经曝光立即引发全网热议。' },
      { type: 'heading', text: '多位当事人先后发声' },
      { type: 'paragraph', text: '事件曝光后，多位疑似当事人先后通过社交媒体发声。第一位发声的A女士声称与该选手交往长达两年，期间该选手以"事业发展需要"为由，要求其对外保密关系。' },
      { type: 'paragraph', text: '紧接着，B女士也在社交平台发布长文，透露在选秀节目录制期间，该选手曾多次私下联系她，两人的聊天记录中不乏暧昧内容。她表示自己也是被蒙在鼓里的受害者。' },
      { type: 'paragraph', text: '第三位C女士则直接放出了与该选手的合照和部分聊天截图，时间线显示这些互动发生在节目总决赛前夕。这意味着该选手在紧张备赛的同时还在处理复杂的感情关系。' },
      { type: 'heading', text: '粉丝反应两极分化' },
      { type: 'paragraph', text: '事件曝光后，该选手的粉丝群体出现严重分裂。一部分粉丝表示"脱粉回踩"，认为偶像的行为严重欺骗了粉丝感情；另一部分粉丝则坚持认为这是有人蓄意抹黑，要求等待官方回应。' },
      { type: 'paragraph', text: '该选手目前尚未对此事作出公开回应，其经纪公司仅表示"正在核实相关情况"。' },
    ],
    relatedArticleIds: [1, 4, 7],
  },
  {
    id: 3,
    title: '某带货主播虚假宣传被实锤，消费者集体维权进行中',
    slug: 'daihuo-zhubo-xujia',
    category: '实锤曝光',
    categorySlug: 'shichui-baoguang',
    author: '维权观察员',
    time: '2025年7月5日 20:00',
    hotScore: '76.5万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Investigative%20news%20concept%20with%20documents%20and%20evidence%20files%2C%20dramatic%20lighting%2C%20mysterious%20corporate%20theme%2C%20dark%20background%20with%20warm%20highlights%2C%20editorial%20photo&width=640&height=480&seq=hot-3-2026&orientation=landscape',
    excerpt: '直播间吹得天花乱坠的产品，实际效果与宣传严重不符。消费者怒了，集体维权行动正在展开。',
    tags: ['虚假宣传', '带货主播', '消费者维权'],
    content: [
      { type: 'paragraph', text: '一场围绕头部带货主播的虚假宣传风波正在持续升级。多位消费者联合发声，指控某知名主播在直播间对产品功效进行夸大甚至虚构的宣传，导致大量消费者上当受骗。' },
      { type: 'heading', text: '实锤证据逐一曝光' },
      { type: 'paragraph', text: '维权消费者向本中心提供了大量证据材料，包括直播录屏、聊天记录、产品检测报告等。其中一份由第三方检测机构出具的报告中显示，该主播声称"含有珍稀成分"的护肤品中，实际检测并未发现相关成分。' },
      { type: 'paragraph', text: '另一个焦点产品是一款号称"可以替代医美"的美容仪器。消费者使用后不仅没有达到宣传效果，多人还出现了皮肤过敏等不良反应。然而主播在直播中从未提及产品可能存在的风险。' },
      { type: 'heading', text: '集体维权进入法律程序' },
      { type: 'paragraph', text: '目前已有超过200名消费者加入了集体维权行列。代理律师表示，根据《消费者权益保护法》和《广告法》相关规定，主播和商家可能面临退一赔三的赔偿责任。' },
      { type: 'paragraph', text: '该主播的直播间已暂时停播，其社交媒体账号的评论区已被大量消费者维权留言刷屏。' },
    ],
    relatedArticleIds: [1, 6, 9],
  },
  {
    id: 4,
    title: '娱乐圈某顶流被拍到深夜约会，工作室未作回应',
    slug: 'dingliu-yuehui-paidao',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    author: '狗仔小分队',
    time: '2025年7月5日 16:00',
    hotScore: '65.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Paparazzi%20night%20photography%20concept%2C%20blurred%20city%20lights%20background%2C%20mysterious%20couple%20silhouette%2C%20cinematic%20moody%20atmosphere%2C%20warm%20street%20lighting%2C%20editorial%20style&width=640&height=480&seq=hot-4-2026&orientation=landscape',
    excerpt: '狗仔蹲守三个月终于拍到实锤画面，画面清晰可见两人亲密互动。工作室至今未作回应，粉丝集体破防。',
    tags: ['顶流明星', '深夜约会', '狗仔实拍'],
    content: [
      { type: 'paragraph', text: '娱乐圈又爆大瓜！某顶流男星被狗仔蹲守三个月后，终于拍到了深夜约会的实锤画面。照片中两人举止亲密，一同从某高档餐厅出来后乘坐同一辆车离开。' },
      { type: 'heading', text: '三个月蹲守始末' },
      { type: 'paragraph', text: '据拍摄的狗仔团队透露，他们早在三个月前就收到了关于该顶流恋情的线索。经过长达三个月的跟踪蹲守，终于在一次深夜活动中捕捉到了关键画面。' },
      { type: 'paragraph', text: '画面显示，当天晚上11点左右，该顶流与一位神秘女子从北京某高端日料餐厅走出。两人虽然都戴着口罩和帽子，但从肢体语言来看关系非同一般——该顶流为女方披外套、开车门的细节被完整记录下来。' },
      { type: 'heading', text: '神秘女子身份引猜测' },
      { type: 'paragraph', text: '画面曝光后，网友迅速展开了对神秘女子身份的大起底。有人根据体型和穿搭风格推测是某知名女演员，也有人认为是圈外富家女。但截至目前，双方均未对此作出任何回应。' },
      { type: 'paragraph', text: '该顶流工作室在事件发酵24小时后仍未发布任何声明，这种沉默态度反而引发了更多猜测。粉丝群体中已经出现了"集体破防"的现象。' },
    ],
    relatedArticleIds: [5, 7, 8],
  },
  {
    id: 5,
    title: '某美食博主被扒抄袭他人创意，粉丝集体脱粉回踩',
    slug: 'meishi-bozhu-chaoxi',
    category: '网红大瓜',
    categorySlug: 'wanghong-dagua',
    author: '创意维权者',
    time: '2025年7月5日 10:00',
    hotScore: '54.8万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Food%20content%20creator%20controversy%20concept%2C%20split%20screen%20comparison%2C%20dramatic%20contrast%20lighting%2C%20social%20media%20drama%20theme%2C%20dark%20moody%20background%2C%20editorial%20photography&width=640&height=480&seq=hot-5-2026&orientation=landscape',
    excerpt: '多位原创博主联合发声，指控其长期系统性抄袭，证据链完整。粉丝大规模脱粉回踩，评论区沦陷。',
    tags: ['美食博主', '抄袭风波', '脱粉回踩'],
    content: [
      { type: 'paragraph', text: '拥有数百万粉丝的美食博主近日陷入严重抄袭风波。多位原创美食博主联合发表声明，指控其长期以来系统性抄袭他人的创意和内容，包括菜品设计、拍摄构图、文案风格等。' },
      { type: 'heading', text: '证据链完整：时间线对比一目了然' },
      { type: 'paragraph', text: '维权博主们整理了一份详细的时间线对比图。例如，某原创博主在2024年3月发布的"创意分子料理"系列视频，与该被指控博主在2024年5月发布的视频在菜品造型、摆盘方式甚至镜头语言上高度相似，但后者从未标注灵感来源。' },
      { type: 'paragraph', text: '更令人震惊的是，该博主不仅抄袭个体创作者的创意，还被发现长期关注海外小众美食博主的账号，将国外创作者的视频内容"本土化"后发布，同样未标注任何来源。' },
      { type: 'heading', text: '粉丝集体脱粉回踩' },
      { type: 'paragraph', text: '事件发酵后，该博主的粉丝数量在48小时内骤降超过50万。评论区从最初的质疑变成了大规模的"脱粉回踩"现场，大量粉丝表示"被骗了很久"、"原以为是个有才华的人，没想到是复制粘贴大师"。' },
      { type: 'paragraph', text: '该博主随后发布道歉声明，承认"在创作过程中确实参考了一些优秀创作者的作品"，但否认"系统性抄袭"的指控。这份道歉未能获得原谅，事件仍在持续发酵中。' },
    ],
    relatedArticleIds: [1, 3, 9],
  },
  {
    id: 6,
    title: '某综艺嘉宾现场互撕视频流出，节目组紧急公关',
    slug: 'zongyi-jiabin-husi',
    category: '独家资源',
    categorySlug: 'dújia-ziyuan',
    author: '独家线人',
    time: '2025年7月4日 22:00',
    hotScore: '43.1万',
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20show%20drama%20behind%20the%20scenes%20concept%2C%20heated%20confrontation%20atmosphere%2C%20studio%20lights%20with%20dramatic%20shadows%2C%20entertainment%20scandal%20theme%2C%20warm%20cinematic%20tones&width=640&height=480&seq=hot-6-2026&orientation=landscape',
    excerpt: '未播出版本遭内部人员泄露，现场火药味十足，嘉宾言辞激烈。节目组连夜启动紧急公关方案。',
    tags: ['综艺节目', '嘉宾互撕', '内容泄露'],
    content: [
      { type: 'paragraph', text: '一段某热门综艺节目未播出的录制片段在网络上疯传，画面中两位嘉宾发生激烈争执，场面一度失控。这段视频的流出让节目组陷入了巨大的公关危机。' },
      { type: 'heading', text: '视频内容：现场火药味十足' },
      { type: 'paragraph', text: '据泄露视频显示，争执起因是两位嘉宾在游戏环节中对规则理解产生分歧。随着讨论升级，两人开始翻旧账，提及彼此过往的一些争议事件，措辞愈发尖锐。' },
      { type: 'paragraph', text: '现场其他嘉宾和主持人的表情显示，这场冲突完全超出了节目预定的脚本范围。主持人多次试图调解但均未成功，最终导演不得不中断录制。' },
      { type: 'heading', text: '泄露源头成谜' },
      { type: 'paragraph', text: '视频的流出方式引发了行业内的广泛讨论。有人怀疑是节目组内部人员出于泄愤目的故意泄露，也有人认为是黑客入侵了节目组的素材服务器。节目组表示已向公安机关报案。' },
      { type: 'paragraph', text: '该节目原定于下月播出的其中一期是否还能正常上线，目前尚未可知。' },
    ],
    relatedArticleIds: [4, 7, 8],
  },
  {
    id: 7,
    title: '深度起底：某MCN机构背后的灰色产业链',
    slug: 'mcn-huise-chanye',
    category: '实锤曝光',
    categorySlug: 'shichui-baoguang',
    author: '调查记者团',
    time: '2025年7月4日 15:00',
    hotScore: '38.6万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Investigative%20journalism%20concept%20about%20corporate%20scandal%2C%20document%20files%20on%20desk%2C%20dramatic%20dark%20lighting%2C%20mysterious%20office%20atmosphere%2C%20noir%20cinematic%20style%2C%20warm%20accent%20highlights&width=900&height=600&seq=featured-1-2026&orientation=landscape',
    excerpt: '从签约到解约，我们独家获取了内部合同和财务流水，揭开MCN行业不为人知的一面。',
    tags: ['MCN机构', '灰色产业', '独家调查'],
    content: [
      { type: 'paragraph', text: 'MCN机构作为连接平台、品牌和内容创作者的中间环节，近年来发展迅猛。然而，其背后的灰色产业链也日益引发关注。本中心经过长达半年的深入调查，独家获取了大量内部资料，试图揭开这个行业不为人知的一面。' },
      { type: 'heading', text: '霸王条款：签约容易解约难' },
      { type: 'paragraph', text: '我们获取的多份MCN机构合同样本显示，大部分合同存在严重的权利义务不对等问题。签约时承诺的资源支持和流量扶持往往含糊其辞，而解约条款却设计精妙、环环相扣。' },
      { type: 'paragraph', text: '一位不愿透露姓名的前签约博主告诉记者："我当初签约时觉得自己遇到了伯乐，但后来才发现合同里的每一个条款都是为困住我们而设计的。想解约？先付百万违约金。"' },
      { type: 'heading', text: '刷量造假：数据的灰色游戏' },
      { type: 'paragraph', text: '调查发现，部分MCN机构通过批量购买水军、使用虚拟机群控等技术手段，为旗下账号进行数据造假。一份内部工作文档显示，某MCN机构的"数据优化"团队拥有超过500台手机设备，可同时操控数千个社交媒体账号进行刷量。' },
      { type: 'heading', text: '税务迷局：壳公司网络' },
      { type: 'paragraph', text: '更为严重的是，一些MCN机构通过注册大量壳公司，构建复杂的资金流转网络，以达到避税甚至洗钱的目的。我们的调查揭示了至少三家头部MCN机构存在类似操作。' },
      { type: 'paragraph', text: '行业监管部门已经注意到了这些问题。据悉，相关部门正在制定针对MCN行业的新监管政策，或将对此类灰色操作进行全面整治。' },
    ],
    relatedArticleIds: [1, 3, 5],
  },
  {
    id: 8,
    title: '独家专访：前艺人助理曝光圈内潜规则内幕',
    slug: 'yiren-zhuli-baoguang',
    category: '独家资源',
    categorySlug: 'dújia-ziyuan',
    author: '独家访谈组',
    time: '2025年7月3日 18:00',
    hotScore: '35.2万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Exclusive%20interview%20concept%20with%20anonymous%20whistleblower%2C%20silhouette%20behind%20frosted%20glass%2C%20dark%20moody%20lighting%2C%20confidential%20theme%2C%20cinematic%20atmosphere%2C%20editorial%20photography&width=900&height=600&seq=featured-2-2026&orientation=landscape',
    excerpt: '从业十年的艺人助理首次公开发声，讲述那些不为人知的娱乐圈生存法则。',
    tags: ['独家专访', '艺人助理', '圈内潜规则'],
    content: [
      { type: 'paragraph', text: '在娱乐圈光鲜亮丽的外表之下，有着一套不为人知的生存法则。本中心独家专访了一位从业十年的艺人助理小李（化名），她以过来人的身份，向我们讲述了这个圈子的真实生态。' },
      { type: 'heading', text: '入行：以为离梦想很近，其实离尊严很远' },
      { type: 'paragraph', text: '"当时大学刚毕业，觉得能进娱乐圈工作特别酷，离明星近、离梦想也近。"小李回忆起自己当初入行的想法，苦笑着说，"后来才发现，所谓的\'离梦想很近\'，其实是用尊严换来的。"' },
      { type: 'paragraph', text: '小李说，艺人助理的工作范畴远远超出一般人的想象——除了行程安排、商务对接等常规工作外，还需要处理艺人各种突发奇想的需求。"半夜两点被叫去买某家特定的蛋糕，这种事情再正常不过了。"' },
      { type: 'heading', text: '潜规则：不止存在于选角环节' },
      { type: 'paragraph', text: '"大家以为的潜规则只是选角时才会发生，但其实它渗透在这个行业的每个环节。"小李透露，从广告代言到综艺节目资源，从热搜位置到社交媒体互动数据，处处都存在隐蔽的利益交换。' },
      { type: 'paragraph', text: '"有一次我亲眼看到，一位投资方的人直接走进化妆间，对还在化妆的艺人不规矩。当时房间里所有人都低着头假装没看见，包括我。这是我迄今为止最羞愧的时刻。"' },
      { type: 'heading', text: '离职后的感悟' },
      { type: 'paragraph', text: '小李最终在去年离开了这个行业。她说："我不后悔这段经历，但我不想再回去了。希望我的分享能让更多人看到这个行业真实的一面，也希望还在圈内的年轻人能保护好自己。"' },
    ],
    relatedArticleIds: [4, 6, 9],
  },
  {
    id: 9,
    title: '数据说话：2025上半年网红翻车事件大盘点',
    slug: '2025-shangbannian-fanche',
    category: '每日大赛',
    categorySlug: 'daily-contest',
    author: '数据分析组',
    time: '2025年7月2日 12:00',
    hotScore: '31.4万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Data%20analysis%20and%20statistics%20visualization%20concept%2C%20dramatic%20graphs%20and%20charts%2C%20dark%20modern%20tech%20atmosphere%2C%20news%20analytics%20theme%2C%20warm%20neon%20highlights%2C%20editorial%20style&width=900&height=600&seq=featured-3-2026&orientation=landscape',
    excerpt: '从年初到现在，已有超过50位网红因各种原因翻车，我们整理了一份完整清单。',
    tags: ['数据盘点', '翻车事件', '2025上半年'],
    content: [
      { type: 'paragraph', text: '2025年刚过半，网红圈的翻车事件已经可以用"应接不暇"来形容。本中心基于公开报道和内部线索，整理了一份上半年网红翻车事件的完整数据报告。' },
      { type: 'heading', text: '数据概览：超过50位网红因何翻车？' },
      { type: 'paragraph', text: '根据我们的统计数据，2025年上半年共有53位粉丝数超过百万的网红因各种原因翻车。其中，税务问题占比最高（28%），其次是私生活丑闻（25%）、虚假宣传（22%）、言论不当（15%）和其他原因（10%）。' },
      { type: 'paragraph', text: '值得注意的是，翻车网红中有近40%来自直播带货领域，这一比例较去年同期上升了12个百分点。这与直播带货行业的野蛮生长和监管趋严密切相关。' },
      { type: 'heading', text: '翻车后结局：有人凉透，有人复出' },
      { type: 'paragraph', text: '翻车后的结局各不相同。约60%的翻车网红在事件后账号被封禁或停更，基本退出了公众视野。但也有少数网红通过有效的危机公关，成功"复活"——其中一位因私生活丑闻翻车的网红，在发布道歉视频三个月后重新开播，首场直播仍有超过50万观众。' },
      { type: 'heading', text: '行业反思：翻车潮背后的问题' },
      { type: 'paragraph', text: '网红翻车潮背后反映的是整个行业生态的问题——流量至上的价值观导致内容创作者过度追求短期利益，忽视了合规经营和个人修养。多位行业观察者呼吁建立更完善的行业自律机制。' },
    ],
    relatedArticleIds: [1, 3, 5],
  },
  {
    id: 10,
    title: '知情人士：某头部主播团队内部矛盾爆发始末',
    slug: 'toubu-zhubo-neibu-maodun',
    category: '网红大瓜',
    categorySlug: 'wanghong-dagua',
    author: '内幕调查组',
    time: '2025年7月1日 09:00',
    hotScore: '28.9万',
    imageUrl: 'https://readdy.ai/api/search-image?query=Team%20conflict%20and%20internal%20drama%20concept%2C%20cracked%20glass%20visual%2C%20dark%20corporate%20atmosphere%2C%20dramatic%20lighting%20contrast%2C%20mysterious%20office%20scene%2C%20cinematic%20photography&width=900&height=600&seq=featured-4-2026&orientation=landscape',
    excerpt: '团队成员向本中心独家爆料，揭开头部主播光鲜背后的团队分裂真相。',
    tags: ['头部主播', '团队矛盾', '内部爆料'],
    content: [
      { type: 'paragraph', text: '在光鲜的直播间背后，头部主播团队内部的暗流涌动往往不为人知。本中心接到该团队一名核心成员独家爆料，揭开了一个千万粉丝级别主播团队内部的分裂真相。' },
      { type: 'heading', text: '利益分配不均：矛盾的核心' },
      { type: 'paragraph', text: '据爆料人透露，该主播团队共有15名核心成员，分别负责选品、运营、内容、客服、物流等工作。然而薪资结构严重失衡——主播本人占据了团队总收入的85%以上，其余14人分配剩余不到15%。' },
      { type: 'paragraph', text: '"我们每天工作超过12个小时，为主播筛选产品、策划内容、处理售后，但拿到手的工资甚至不如普通白领。"爆料人表示，这种不公平的分配方式已经导致多名核心成员提出离职。' },
      { type: 'heading', text: '股权之争：从合伙人到对手' },
      { type: 'paragraph', text: '更为复杂的是，该团队的三位联合创始人之间也存在严重分歧。据了解，其中两位创始人认为公司发展已经过度依赖主播个人IP，提出分散风险、孵化新主播的战略方向，但被以主播为首的创始方否决。这场关于公司未来的争论已经持续了半年之久。' },
      { type: 'paragraph', text: '目前，两方已经进入实质性的谈判阶段，或将对公司股权结构进行重大调整。' },
    ],
    relatedArticleIds: [1, 5, 7],
  },
];

export const getCategoryArticles = (slug: string) => {
  return allArticles.filter((a) => a.categorySlug === slug);
};

export const getArticle = (slug: string) => {
  return allArticles.find((a) => a.slug === slug) || null;
};

export const getRelatedArticles = (ids: number[]) => {
  return allArticles.filter((a) => ids.includes(a.id));
};